import { GET, } from '@/components/api';
import { LOGIN_URL } from '../config';

/** 获取当前登录用户的用户信息 */
export function login_web_getLoginInfo_api() {
  return GET(`${LOGIN_URL}/getLoginInfo`);
}
/** 登出 */
export function login_web_logout_api() {
  return GET(`${LOGIN_URL}/logout`);
}
